import { cn } from '@/utils/cn'
import { HTMLAttributes } from 'react'
import { ProductThumbnailUI } from './ui/product-thumbnail-ui'
import { useProductThumbnail } from './use-product-thumbnail'
import { ProductThumbnailPending } from './ui/product-thumbnail-pending'

export type ProductThumbnailProps = {
  productId: string
}

export const ProductThumbnail = ({
  className,
  productId,
  ...props
}: ProductThumbnailProps & HTMLAttributes<HTMLDivElement>) => {
  const { data: thumbnail, pending } = useProductThumbnail(productId)
  if (!thumbnail) {
    return null
  }
  if (pending) {
    return <ProductThumbnailPending />
  }

  return (
    <ProductThumbnailUI {...thumbnail} {...props} className={cn(className)} />
  )
}
